module.exports = __webpack_public_path__ + "img/midi.52be53e3.svg";